import { } from 'googlemaps'
import { Observable, merge } from 'rxjs';
import { debounceTime, map as mapEvent } from 'rxjs/operators';
import { Geodetic, MapProjection, PixelProjection } from './map-types'
import { SpatialBounds } from '../data-source/types';

export const createMapBoundsObservable = (map: Map, bounceTime?: number): Observable<TLMDMapBounds> => {

  let mapBoundsObservable = map.getObservable('bounds_changed');
  let mapOuterBoundsObservable = map.getObservable('outer_bounds_changed');

  let boundsObservable: Observable<TLMDMapBounds> = merge(
    mapBoundsObservable,
    mapOuterBoundsObservable
  ).pipe(
    debounceTime(250),
    mapEvent(_evt => map.getBounds())
  )

  return boundsObservable;
}

export interface Map {
  /**
   * @return the unique is among the instances of this class
   */
  getId: () => string,
  getContainer: () => HTMLDivElement,
  getProjection: () => MapProjection,
  /**
   * @param center: when absent, the map's anchor (i.e. the original map center) is taken as origin 
  */
  getLocalProjection: (origin?: Geodetic) => PixelProjection,
  getGMap: () => google.maps.Map,
  getBounds: () => TLMDMapBounds,
  boundsObservable: Observable<Event>,
  //get observables from the map
  getObservable: (event: string) => Observable<any>,
  getAnchor: () => Geodetic,

  getMapSettings: () => { centre : { lat : number, lng : number }, zoom : number, type : string },
  setMapSettings: ( settings: { centre : { lat : number, lng : number }, zoom : number, type : string } ) => void

}
export interface TLMDMapBounds {
  total: MapBounds,
  visible: MapBounds
}

export enum MapAction {
  UPDATE = 'update',
  NEW = 'new',
  ZOOM_IN = 'zoom-in',
  ZOOM_OUT = 'zoom-out',
  MOVE = 'move'
}
export interface MapBoundsAnalysisResult {
  boundsToUpdate: MapBounds,
  boundsesToAdd: MapBounds[], // TODO i know.......rename to boundsToAdd using refactoring tools once in full TS control
  boundcesToRemove: MapBounds[], // TODO i know.......rename to boundsToRemove using refactoring tools once in full TS control
  action: MapAction
}
export interface MapBounds extends SpatialBounds {
  version: number,
  difference: (oldBounds: MapBounds, version: number) => MapBoundsAnalysisResult,
  overlap: (bounds: SpatialBounds | { lat: number, lng: number }) => boolean,
  //containsLatLng: (latLng: { lat: number, lng: number }) => boolean,
  //contains: (lat: number, lng: number) => boolean,
  inside: (bounds: SpatialBounds | { lat: number, lng: number }) => boolean,
  equals: (bounds: SpatialBounds | { lat: number, lng: number }) => boolean,
  unite: (bounds: MapBounds | SpatialBounds) => void,
  union: (bounds: MapBounds | SpatialBounds) => MapBounds,
  intersection: (bounds: MapBounds | SpatialBounds) => MapBounds,
  complement: (bounds: MapBounds | SpatialBounds) => MapBounds[]

  getNorthWest: () => { lat: number, lng: number },
  getNorthEast: () => { lat: number, lng: number },
  getSouthWest: () => { lat: number, lng: number },
  getSouthEast: () => { lat: number, lng: number },
  getNorth: () => number,
  getEast: () => number,
  getSouth: () => number,
  getWest: () => number
  
}

export const  getNorthWest = (bounds: SpatialBounds) :{ lat: number, lng: number } => { return { lat: bounds.north, lng: bounds.west }; };
export const  getNorthEast = (bounds: SpatialBounds) :{ lat: number, lng: number } => { return { lat: bounds.north, lng: bounds.east }; };
export const  getSouthWest = (bounds: SpatialBounds) :{ lat: number, lng: number } => { return { lat: bounds.south, lng: bounds.west }; };
export const  getSouthEast = (bounds: SpatialBounds) :{ lat: number, lng: number } => { return { lat: bounds.south, lng: bounds.east }; };

